import { ApiResponseDto } from '../common/interfaces/common.interface';
import { CreatePostDto, GetPostsParams, PostDetailsDto, PostDto } from '../common/interfaces/infoboard.interface';
import api from './api';

export const getPosts = async (params: GetPostsParams = {}): Promise<ApiResponseDto<PostDto[]>> => {
  const queryParams: any = {
    page: params.page ?? 1,
    perPage: params.perPage ?? 10
  };
  if (params.name && params.name.trim().length > 0) queryParams.name = params.name;
  if (params.kindergartenIds?.length) queryParams.kindergartenIds = params.kindergartenIds;
  if (params.groupIds?.length) queryParams.groupIds = params.groupIds;
  if (params.createdBy) queryParams.createdBy = params.createdBy;
  if (params.dateFrom) queryParams.dateFrom = params.dateFrom;
  if (params.dateTo) queryParams.dateTo = params.dateTo;

  const response = await api.get(`/post/list`, {
    params: queryParams,
    paramsSerializer: params => {
      const searchParams = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach(v => searchParams.append(key, v));
        } else if (value !== undefined && value !== null) {
          searchParams.append(key, String(value));
        }
      });
      return searchParams.toString();
    }
  });
  return response.data;
};

export const createPost = async (createPostDto: CreatePostDto): Promise<ApiResponseDto<void>> => {
  const response = await api.post(`post/admin`, createPostDto);
  return response.data;
};

export const fetchPostDetails = async (postId: string): Promise<ApiResponseDto<PostDetailsDto>> => {
  const response = await api.get(`/post/${postId}/details`);

  return response.data;
};

export const deletePost = async (postId: string): Promise<ApiResponseDto<void>> => {
  const response = await api.delete(`/post/${postId}`);

  return response.data;
};

export const updatePost = async (postId: string, updatePostDto: CreatePostDto): Promise<ApiResponseDto<void>> => {
  const response = await api.patch(`post/${postId}/update/admin`, updatePostDto);
  return response.data;
};
